import { configureStore } from '@reduxjs/toolkit'
import AlertReducer from '../features/alert/alertSlice'
import ModelReducer from '../features/model/modelSlice'

export const store = configureStore({
    reducer: {
        alerts: AlertReducer,
        setModel: ModelReducer,
    },

},
    window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__())
